'use strict';

module.exports = {
  CARD: 'card'
};


/*****************
 ** WEBPACK FOOTER
 ** ./_sortable-simple/ItemTypes.js
 ** module id = 149
 ** module chunks = 0
 **/